import { ContentStore } from '@/entities/feed-block/model/content-store'
import { IUser } from '@/entities/user/model/types'
import SearchUserComponent from '@/features/search-user/ui'
import useNotifier, { createCalls } from '@/shared/lib/use-notifier'
import { LangStore } from '@/shared/model/store'
import { ContractsStore } from '@/shared/model/store/contracts-store'
import { Button } from '@/shared/ui'
import { useState } from 'react'

interface Props {
	closeModal: () => void
}

const TransferToken = ({ closeModal }: Props) => {
	const { activePost } = ContentStore()
	const { contracts } = ContractsStore()
	const { langPack } = LangStore()

	const [user, setUser] = useState<IUser | null>(null)

	const is_npo_owner = activePost?.nft.owner?.is_npo
	const owner = activePost?.nft.owner?.address

	const { writeContract, writeContractMulticall } = useNotifier({
		onSuccess() {
			closeModal()
		}
	})

	const transferhandler = async () => {
		if (!user) return
		const call = {
			address: contracts.ContentNFT.address,
			abi: contracts.ContentNFT.abi,
			functionName: 'transferFrom',
			args: [owner, user.address, activePost?.savva_cid]
		}
		if (is_npo_owner) {
			writeContractMulticall(owner, createCalls([call]))
			return
		}
		writeContract(call)
	}

	return (
		<div>
			<div className='flex w-full text-[14px] text-[grey]'>{langPack('nft.transfer_description')}</div>
			{activePost?.nft.on_market && (
				<div className='mt-6 flex w-full text-[14px] text-[#cf4343]'>{langPack('nft.transfer_on_market_warning')}</div>
			)}
			<div className='mt-6 flex flex-row items-end gap-4'>
				<SearchUserComponent onSelect={setUser} selected={user} />
				<Button onClick={transferhandler} disabled={!user}>
					{langPack('nft.transfer_token')}
				</Button>
			</div>
		</div>
	)
}

export default TransferToken
